import Repository from "@/services/Repository";
import { SchoolUser } from "../models/People";

const resource = "/classrooms";

const transformer = item => {
  var teacher = {};
  var asstTeacher = {};

  if (typeof item.currentTeacher !== "undefined") {
    teacher = new SchoolUser(item.currentTeacher);
  } else {
    teacher = null;
  }

  if (typeof item.currentAsstTeacher !== "undefined") {
    asstTeacher = new SchoolUser(item.currentAsstTeacher);
  } else {
    asstTeacher = null;
  }

  return {
    _id: item._id,
    number: item.number,
    title: item.title,
    teacher,
    asstTeacher,
    studentCount: item.studentCount,
    studyClass: item.studyClass
  };
};

export default {
  fetch() {
    return new Promise((resolve, reject) => {
      Repository.get(`${resource}`)
        .then(response => {
          let result = response.data.map(transformer);
          resolve(result);
        })
        .catch(error => {
          reject(error);
        });
    });
  },
  fetchOne(roomId) {
    let params = { populate: "currentTeacher" };
    return Repository.get(`${resource}/id/${roomId}`, { params });
  },
  post(data) {
    return Repository.post(`${resource}/`, data);
  },
  update(editingClassroom) {
    return Repository.put(
      `${resource}/id/${editingClassroom._id}`,
      editingClassroom
    );
  },
  changeTeacher({ teacher, assist, classroom, schoolYear }) {
    return Repository.put(`${resource}/change-teacher/id/${classroom}`, {
      teacher,
      assist,
      classroom,
      schoolYear
    });
  },
  delete(roomId) {
    return Repository.delete(`${resource}/id/${roomId}`);
  }
};
